import CarouselBase from "./CarouselBase";
import CarouselMobile from "./CarouselMobile";

const Carousel = Object.assign(CarouselBase, {
  Mobile: CarouselMobile,
});

export default Carousel;
